module.exports = "/_next/static/images/cc9a40374cdf80d6c5e812373b2919e2-rates-icon-new.svg.webp";